import React from 'react'
import Homelayout from '../../Components/Homelayout'
import { useLocation, useParams, useSearchParams } from 'react-router-dom'
import PsychomatricProfileTest from './PsychomatricProfileTest'
import CareerCounselling from './Careercounselling'

const Screens : any = {
  "career-counselling" : CareerCounselling,
}

const Profile = () => {
  const {nav} = useParams<{nav : string}>()
  // const searchParams : any = useSearchParams();
  const Screen = Screens[nav || "career-counselling"]
  return (
    <>
      <Homelayout>
          <Screen />
      </Homelayout>
    </>
  )
}

export default Profile